import { ContentLoading } from '@/components/common/content-loading';
import HorizontalView from '@/components/feature/floor-guide/horizontal-view';
import VerticalView from '@/components/feature/floor-guide/vertical-view';
import { useOrientation } from '@/hooks';
import { useFloorGuideStore } from '@/stores/floorGuideStore';
import { Suspense, useEffect } from 'react';


export default function FloorGuidePage() {
    const { isHorizontal } = useOrientation();
    const { resetSelectedPoi, resetFloorGuideType, resetSelectedParkingSlot } = useFloorGuideStore();

    useEffect(() => {
        return () => {
            resetSelectedPoi();
            resetFloorGuideType();
            resetSelectedParkingSlot();
        };
    }, [resetSelectedPoi, resetFloorGuideType, resetSelectedParkingSlot]);

    return (
        <main className="relative h-full w-full overflow-hidden">
            <Suspense fallback={<ContentLoading loading />}>{isHorizontal ? <HorizontalView key="horizontal" /> : <VerticalView key="vertical" />}</Suspense>
        </main>
    );
}
